import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { VehicleActions } from './vehicle.actions';
import { catchError, map, mergeMap, of, tap } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { FleetService } from '@core/services/fleet.service';
import { HelperService } from '@core/helper/helper.service';

@Injectable()
export class VehicleEffects {
  private actions$ = inject(Actions);
  private fleetService = inject(FleetService);
  private translateService = inject(TranslateService);
  helperService = inject(HelperService);

  getVehicles$ = createEffect(() =>
    this.actions$.pipe(
      ofType(VehicleActions.loadVehicles),
      mergeMap((data) => {
        return this.fleetService.getVehicleList(data).pipe(
          map((response) =>
            response.success
              ? VehicleActions.loadVehiclesSuccess(response)
              : VehicleActions.loadVehiclesFailure(response)
          ),
          catchError((error) =>
            of(
              VehicleActions.loadVehiclesFailure({
                error,
                success: false,
                message: this.translateService.instant('Something went wrong'),
              })
            )
          )
        );
      })
    )
  );

  addVehicle$ = createEffect(() =>
    this.actions$.pipe(
      ofType(VehicleActions.addEditVehicle),
      mergeMap((data) =>
        this.fleetService.updateVehicle(data).pipe(
          map((vehicle) => {
            if (vehicle.success) {
              return data.id
                ? VehicleActions.updateVehicleSuccess(vehicle)
                : VehicleActions.addVehicleSuccess(vehicle);
            } else return VehicleActions.addVehicleFailure(vehicle);
          }),
          catchError((error) =>
            of(
              VehicleActions.addVehicleFailure({
                error,
                success: false,
                message: this.translateService.instant('Something went wrong'),
              })
            )
          )
        )
      )
    )
  );

  exportExcel$ = createEffect(() =>
    this.actions$.pipe(
      ofType(VehicleActions.exportExcelVehicles),
      mergeMap((payload) =>
        this.fleetService.getVehicleList().pipe(
          map((data) =>
            data.success
              ? VehicleActions.exportExcelVehiclesSuccess({
                  ...data,
                  ...payload,
                })
              : VehicleActions.exportExcelVehiclesFailure(data)
          ),
          catchError((error) =>
            of(
              VehicleActions.exportExcelVehiclesFailure({
                error,
                success: false,
                message: this.translateService.instant('Something went wrong'),
              })
            )
          )
        )
      )
    )
  );

  exportExcelSuccess = createEffect(
    () =>
      this.actions$.pipe(
        ofType(VehicleActions.exportExcelVehiclesSuccess),
        tap((data) => {
          if (data.data.length === 0) {
            this.helperService.showErrorToastr(
              this.translateService.instant('There is no data to export.')
            );
            return;
          }
          this.helperService.exportVehicleExcel(data.data);

          // if (data.start_date && data.end_date)
          //   this.helperService.inspectionPDF(
          //     data.data,
          //     data.user?.label ?? 'All',
          //     data.start_date,
          //     data.end_date
          //   );
        })
      ),
    { dispatch: false }
  );

  deleteTimesheet$ = createEffect(() =>
    this.actions$.pipe(
      ofType(VehicleActions.deleteVehicle),
      mergeMap((data) =>
        this.fleetService.deleteVehicle(data.id).pipe(
          map((response) =>
            response.success
              ? VehicleActions.deleteVehicleSuccess({
                  ...response,
                  id: data.id,
                })
              : VehicleActions.deleteVehicleFailure(response)
          ),
          catchError((error) =>
            of(
              VehicleActions.deleteVehicleFailure({
                error,
                success: false,
                message: this.translateService.instant('Something went wrong'),
              })
            )
          )
        )
      )
    )
  );
}
